// extracted by mini-css-extract-plugin
module.exports = {"linksComponent":"links_linksComponent__SnMZc"};